package fyi.moko.hotpl.domain.usecase

import fyi.moko.hotpl.domain.model.Place
import fyi.moko.hotpl.domain.repository.PlaceRepository

/** One-shot fetch of a place, used to pre-fill the edit form. */
class GetPlaceUseCase(
    private val repository: PlaceRepository,
) {
    suspend operator fun invoke(id: String): Place? = repository.getPlace(id)
}
